import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpInterceptor } from './httpInterceptor.service';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { SessionHandlerService } from './sessionHandler.service';
import { CommonConstants } from '../utilities/commonConstants';
@Injectable({
  providedIn: 'root'
})
export class PlanDetailsService {
  bflJourney: any;
  constructor(private _httpInterceptor: HttpInterceptor,
    private _http: HttpClient,
    private sessionHandlerService: SessionHandlerService) { }
  public GetQuoteIds(quoteId: string): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.getPollingQuotes;
    url = url.replace('{0}', quoteId);
    return this._httpInterceptor.GetPollingRetry(url, true);
  }
  rolloverPlanlisting(data): Observable<ActivitiModel.MTResponse<any>> {
    /*
    JSON.parse() is used here to convert string value to boolean
    When we store values in session they get stored in string
    */
    data.isSSO = JSON.parse(this.sessionHandlerService.GetSession(CommonConstants.CookieKeys.ssoEnabled) || 'false');
    let url = ConfigService.getInstance().getConfigObject().APIURL.rolloverPlanList;
    return this._httpInterceptor.Post(url, data);
  }
  public PostCallService(requestData: any): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.modifyPlanInsuredData;
    url = url.replace('{applicationId}', requestData.applicationId);
    return this._httpInterceptor.Post(url, requestData.payload);
  }
  public CallBuyNowAPI(requestData: any): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.modifyPlanInsuredData;
    url = url.replace('{applicationId}', requestData.payload.applicationId);
    return this._httpInterceptor.Post(url, requestData);
  }
  public GetHeaderDetails(quoteId: string, applicationId: any): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance()
      .getConfigObject().APIURL.getSummaryDetails;
    url = url.replace('{applicationId}', applicationId ? applicationId : 0);
    url = url.replace('{quoteId}', quoteId ? quoteId : 0);
    return this._httpInterceptor.Get(url, true);
  }
  public DownloadBrochure(variantCode: string): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.downloadPlanBrochureNew;
    url = url.replace('{variantcode}', variantCode);
    return this._httpInterceptor.Get(url, true);
  }

  // mock jsons
  public GetJSON(url: any) {
    return this._http.get(url);
  }

  /*** Get the AEM data */
  public getAemDetails(): Observable<any> {
    this.bflJourney = true;
    let url = this.bflJourney ? ConfigService.getInstance().getConfigObject().AEMURL.HealthListAem : ConfigService.getInstance().getConfigObject().AEMURL.HealthListAembfdl;
    return this._httpInterceptor.GetAem(url);
  }

  public PostSaveQuoteCriteria(requestData: any): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.quoteCriteria;
    url = url.replace('{applicationId}', requestData.payload.applicationId);
    return this._httpInterceptor.Post(url, requestData);
  }
  public searchCashlessHospital(principalKey, hospitalName, cityKey, pincodeKey) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.cashlessHospital;
    url = url.replace('{principalKey}', principalKey);
    url = url.replace('{hospitalName}', hospitalName);
    url = url.replace('{cityKey}', cityKey);
    url = url.replace('{pincodeKey}', pincodeKey);
    return this._httpInterceptor.Get(url);
  }
  public PostClickToCall(requestData: any): Observable<ActivitiModel.MTResponse<any>> {
    let url = ConfigService.getInstance().getConfigObject().APIURL.postLeadType;
    url = url.replace('{applicationId}', requestData.payload.applicationId);
    url = url.replace('{leadType}', requestData.payload.leadType);
    return this._httpInterceptor.Post(url, null);
  }
}
